import {Injectable} from "@angular/core";
import {AuthService} from "./auth.service";
import {LanguageEnum} from "../../app/global/global-settings/enums/language.enum";
import {TranslatableFieldInterface} from "../interfaces/translatable-field.interface";

@Injectable({
    providedIn: 'root'
})
export class LanguagesService {
    constructor(
        private authService: AuthService,
    ) {
    }

    getAvailableLanguages(): LanguageEnum[] {
        const availableLanguages = [];
        const company = this.authService.getUser().company;

        if (!company.languages) {
            return [];
        }

        for (const lang of Object.entries(company.languages)) {
            if (lang[1]) {
                availableLanguages.push(lang[0] as LanguageEnum);
            }
        }

        return availableLanguages;
    }

    prepareLangValues(translations = null, defaultValue: string = null): TranslatableFieldInterface {
        translations = translations || {};
        const languages = this.authService.getUser().company.languages || {
            [LanguageEnum.POLISH]: true,
            [LanguageEnum.ENGLISH]: false,
            [LanguageEnum.GERMAN]: false,
            [LanguageEnum.SPANISH]: false,
            [LanguageEnum.RUSSIAN]: false,
            [LanguageEnum.ITALIAN]: false,
            [LanguageEnum.UKRAINIAN]: false,
            [LanguageEnum.FRENCH]: false,
        }
        for (const lang of Object.entries(languages)) {
            if (!translations[lang[0]]) {
                translations[lang[0]] = defaultValue;
            }
        }

        return translations;
    }
}